export const _checkTypeOfWebinar = (typeOf) => {
    return typeOf == 'skp';
}

export const _checkTypeOfEcourse = (typeOf) => {
    return typeOf == 'ecourse';
}

export const _checkIsUserPassedPostTest = (skp) => {
    if (skp.status == 2) {
        return true
    }
}

export const _isShowSponsoreChannel = (skp) => {
    return skp.sponsorship || skp.channel;
}

export const _sponsoreChannelLogo = (skp) => {
    var logoStr = "";
    if (skp.channel) {
      logoStr = skp.channel.logo;
    } else if (skp.sponsorship) {
      logoStr = skp.sponsorship.logo;
    }
    return logoStr;
}

export const _sponsoreChannelCategory = (skp) => {
    var categoryStr = "Dipersembahkan oleh";
    if (skp.channel) {
      categoryStr = skp.channel.channel_sponsorship_name;
    }
    return categoryStr;
}

export const _sponsoreChannelName = (skp) => {
    var nameStr = "";
    if (skp.channel) {
      nameStr = skp.channel.name;
    } else if (skp.sponsorship) {
      nameStr = skp.sponsorship.name;
    }
    return nameStr;
}

export const _iconReferenceShow = (data) => {
    return data == "show";
};
  
export const _iconReferenceHide = (data) => {
    return data == "hide";
};

export const _isShowReference = (skp) => {
    if (skp.reference == "") {
        return false
    } else {
        return true
    }
};

export const _isShowReviewedBy = (skp) => {
    if (skp.reviewed_by == "") {
        return false
    } else {
        return true
    }
};

export const _checkSkpPoint = (skp_point) => {
    return skp_point > 0;
}

export const _checkSkpTypeOf = (skp) => {
    if(skp.type_of == 'ecourse'){
        return true
    }
}

export const iterateFieldListName = (field_list) => {
    var listSpeciality = []
    var fieldListLength = field_list.length - 1;
    for (var i = 0; i < field_list.length; i++) {
        if(i < fieldListLength){
            listSpeciality += `${field_list[i].name}, `
        }else{
            listSpeciality += field_list[i].name
        }
    }
    return listSpeciality
}

export const _isVideoUrlAttached = (skp) => {
    if(skp.video_url != '') {
        return true
    }
}

export const _isSkpDetailExpired = (skp) => {
    if(skp.is_show_expired_button == true) {
        return true
    }
}

export const _sessionStorageSkp = (skp) => {
    var skpObj = {};
    skpObj.title = skp.title;
    skpObj.skpType = _checkSkpTypeOf(skp) ? "ecourse_module" : "skp";
    sessionStorage.setItem("skp-object-data", JSON.stringify(skpObj))
}

export const _textButtonSkpDetail = (status) => {
    if (status == 0) {
        return "Mulai Tes"
    } else if (status == 1) {
        return "Coba Tes Lagi"
    }
}

export const _getTitleFailedPage = (skp) => {
    return skp.type_of == "ecourse" ? `Maaf, Anda belum berhasil lulus mengerjakan ${skp.title}` : "Maaf, Anda belum berhasil lulus mengerjakan post test ini";
}

export const _getTitleSuccessPage = (skp) => {
    return skp.type_of == "ecourse" ? `Selamat Anda berhasil lulus mengerjakan ${skp.title}` : "Selamat Anda berhasil lulus post test webinar ini.";
}

export const _checkEmptyData = (data) => {
    return data != "";
}